import { render, staticRenderFns } from "./prinMng.vue?vue&type=template&id=3b4e2120&scoped=true"
import script from "./prinMng.vue?vue&type=script&lang=js"
export * from "./prinMng.vue?vue&type=script&lang=js"
import style0 from "./prinMng.vue?vue&type=style&index=0&id=3b4e2120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e2120",
  null
  
)

export default component.exports